var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.4875 2 2 6.4875 2 12C2 17.5125 6.4875 22 12 22C17.5125 22 22 17.5125 22 12C22 6.4875 17.5125 2 12 2ZM20.9875 11.5H17.5C17.4125 8.075 16.4125 5.1625 14.9375 3.4875C18.3125 4.6625 20.775 7.775 20.9875 11.5ZM11.5 3.0625V11.5H7.5125C7.6375 7.175 9.3625 3.5625 11.5 3.0625ZM11.5 12.5V20.9375C9.3625 20.4375 7.6375 16.825 7.5125 12.5H11.5ZM12.5 20.9375V12.5H16.4875C16.3625 16.825 14.6375 20.4375 12.5 20.9375ZM12.5 11.5V3.0625C14.6375 3.5625 16.3625 7.175 16.4875 11.5H12.5ZM9.075 3.4875C7.5875 5.1625 6.6 8.075 6.5125 11.5H3.0125C3.225 7.775 5.6875 4.6625 9.075 3.4875ZM3.0125 12.5H6.5C6.5875 15.925 7.5875 18.8375 9.0625 20.5125C5.6875 19.3375 3.225 16.225 3.0125 12.5ZM14.925 20.5125C16.4125 18.85 17.4 15.925 17.4875 12.5H20.975C20.775 16.225 18.3125 19.3375 14.925 20.5125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.5eba82ee85b4b1b54838ec84fb10fd2a.svg";
export { ForwardRef as ReactComponent };